module.exports = __webpack_public_path__ + "img/bg_ghost_02@3x.b9930736.png";